/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedCliLoginRouteImport } from './routes/_authenticated.cli-login'
import { Route as AuthenticatedAdminReviewRouteImport } from './routes/_authenticated.admin.review'
import { Route as AuthenticatedAdminSourcesRouteImport } from './routes/_authenticated.admin.sources'
import { Route as AuthenticatedEventsIndexRouteImport } from './routes/_authenticated.events.index'
import { Route as AuthenticatedEventsMineRouteImport } from './routes/_authenticated.events.mine'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated.events.new'
import { Route as AuthenticatedOrganisersIndexRouteImport } from './routes/_authenticated.organisers.index'
import { Route as AuthenticatedOrganisersNewRouteImport } from './routes/_authenticated.organisers.new'
import { Route as AuthenticatedVenuesIndexRouteImport } from './routes/_authenticated.venues.index'
import { Route as AuthenticatedVenuesNewRouteImport } from './routes/_authenticated.venues.new'
import { Route as AuthenticatedWeekAreaSlugRouteImport } from './routes/_authenticated.week.$areaSlug'
import { Route as AuthenticatedEventsEventIdIndexRouteImport } from './routes/_authenticated.events.$eventId.index'
import { Route as AuthenticatedEventsEventIdEditRouteImport } from './routes/_authenticated.events.$eventId.edit'
import { Route as AuthenticatedOrganisersOrganiserIdIndexRouteImport } from './routes/_authenticated.organisers.$organiserId.index'
import { Route as AuthenticatedOrganisersOrganiserIdEditRouteImport } from './routes/_authenticated.organisers.$organiserId.edit'
import { Route as AuthenticatedSeriesSeriesIdEditRouteImport } from './routes/_authenticated.series.$seriesId.edit'
import { Route as AuthenticatedVenuesVenueIdIndexRouteImport } from './routes/_authenticated.venues.$venueId.index'
import { Route as AuthenticatedVenuesVenueIdEditRouteImport } from './routes/_authenticated.venues.$venueId.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCliLoginRoute = AuthenticatedCliLoginRouteImport.update({
  id: '/cli-login',
  path: '/cli-login',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminReviewRoute =
  AuthenticatedAdminReviewRouteImport.update({
    id: '/admin/review',
    path: '/admin/review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSourcesRoute =
  AuthenticatedAdminSourcesRouteImport.update({
    id: '/admin/sources',
    path: '/admin/sources',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsIndexRoute =
  AuthenticatedEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsMineRoute = AuthenticatedEventsMineRouteImport.update({
  id: '/events/mine',
  path: '/events/mine',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganisersIndexRoute =
  AuthenticatedOrganisersIndexRouteImport.update({
    id: '/organisers/',
    path: '/organisers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisersNewRoute =
  AuthenticatedOrganisersNewRouteImport.update({
    id: '/organisers/new',
    path: '/organisers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVenuesIndexRoute =
  AuthenticatedVenuesIndexRouteImport.update({
    id: '/venues/',
    path: '/venues/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVenuesNewRoute = AuthenticatedVenuesNewRouteImport.update({
  id: '/venues/new',
  path: '/venues/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWeekAreaSlugRoute =
  AuthenticatedWeekAreaSlugRouteImport.update({
    id: '/week/$areaSlug',
    path: '/week/$areaSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsEventIdIndexRoute =
  AuthenticatedEventsEventIdIndexRouteImport.update({
    id: '/events/$eventId/',
    path: '/events/$eventId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsEventIdEditRoute =
  AuthenticatedEventsEventIdEditRouteImport.update({
    id: '/events/$eventId/edit',
    path: '/events/$eventId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisersOrganiserIdIndexRoute =
  AuthenticatedOrganisersOrganiserIdIndexRouteImport.update({
    id: '/organisers/$organiserId/',
    path: '/organisers/$organiserId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisersOrganiserIdEditRoute =
  AuthenticatedOrganisersOrganiserIdEditRouteImport.update({
    id: '/organisers/$organiserId/edit',
    path: '/organisers/$organiserId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSeriesIdEditRoute =
  AuthenticatedSeriesSeriesIdEditRouteImport.update({
    id: '/series/$seriesId/edit',
    path: '/series/$seriesId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVenuesVenueIdIndexRoute =
  AuthenticatedVenuesVenueIdIndexRouteImport.update({
    id: '/venues/$venueId/',
    path: '/venues/$venueId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVenuesVenueIdEditRoute =
  AuthenticatedVenuesVenueIdEditRouteImport.update({
    id: '/venues/$venueId/edit',
    path: '/venues/$venueId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/cli-login': typeof AuthenticatedCliLoginRoute
  '/admin/review': typeof AuthenticatedAdminReviewRoute
  '/admin/sources': typeof AuthenticatedAdminSourcesRoute
  '/events/mine': typeof AuthenticatedEventsMineRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/organisers/new': typeof AuthenticatedOrganisersNewRoute
  '/venues/new': typeof AuthenticatedVenuesNewRoute
  '/week/$areaSlug': typeof AuthenticatedWeekAreaSlugRoute
  '/events/': typeof AuthenticatedEventsIndexRoute
  '/organisers/': typeof AuthenticatedOrganisersIndexRoute
  '/venues/': typeof AuthenticatedVenuesIndexRoute
  '/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditRoute
  '/organisers/$organiserId/edit': typeof AuthenticatedOrganisersOrganiserIdEditRoute
  '/series/$seriesId/edit': typeof AuthenticatedSeriesSeriesIdEditRoute
  '/venues/$venueId/edit': typeof AuthenticatedVenuesVenueIdEditRoute
  '/events/$eventId/': typeof AuthenticatedEventsEventIdIndexRoute
  '/organisers/$organiserId/': typeof AuthenticatedOrganisersOrganiserIdIndexRoute
  '/venues/$venueId/': typeof AuthenticatedVenuesVenueIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/cli-login': typeof AuthenticatedCliLoginRoute
  '/admin/review': typeof AuthenticatedAdminReviewRoute
  '/admin/sources': typeof AuthenticatedAdminSourcesRoute
  '/events/mine': typeof AuthenticatedEventsMineRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/organisers/new': typeof AuthenticatedOrganisersNewRoute
  '/venues/new': typeof AuthenticatedVenuesNewRoute
  '/week/$areaSlug': typeof AuthenticatedWeekAreaSlugRoute
  '/events': typeof AuthenticatedEventsIndexRoute
  '/organisers': typeof AuthenticatedOrganisersIndexRoute
  '/venues': typeof AuthenticatedVenuesIndexRoute
  '/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditRoute
  '/organisers/$organiserId/edit': typeof AuthenticatedOrganisersOrganiserIdEditRoute
  '/series/$seriesId/edit': typeof AuthenticatedSeriesSeriesIdEditRoute
  '/venues/$venueId/edit': typeof AuthenticatedVenuesVenueIdEditRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdIndexRoute
  '/organisers/$organiserId': typeof AuthenticatedOrganisersOrganiserIdIndexRoute
  '/venues/$venueId': typeof AuthenticatedVenuesVenueIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthRoute
  '/_authenticated/cli-login': typeof AuthenticatedCliLoginRoute
  '/_authenticated/admin/review': typeof AuthenticatedAdminReviewRoute
  '/_authenticated/admin/sources': typeof AuthenticatedAdminSourcesRoute
  '/_authenticated/events/mine': typeof AuthenticatedEventsMineRoute
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute
  '/_authenticated/organisers/new': typeof AuthenticatedOrganisersNewRoute
  '/_authenticated/venues/new': typeof AuthenticatedVenuesNewRoute
  '/_authenticated/week/$areaSlug': typeof AuthenticatedWeekAreaSlugRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
  '/_authenticated/organisers/': typeof AuthenticatedOrganisersIndexRoute
  '/_authenticated/venues/': typeof AuthenticatedVenuesIndexRoute
  '/_authenticated/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditRoute
  '/_authenticated/organisers/$organiserId/edit': typeof AuthenticatedOrganisersOrganiserIdEditRoute
  '/_authenticated/series/$seriesId/edit': typeof AuthenticatedSeriesSeriesIdEditRoute
  '/_authenticated/venues/$venueId/edit': typeof AuthenticatedVenuesVenueIdEditRoute
  '/_authenticated/events/$eventId/': typeof AuthenticatedEventsEventIdIndexRoute
  '/_authenticated/organisers/$organiserId/': typeof AuthenticatedOrganisersOrganiserIdIndexRoute
  '/_authenticated/venues/$venueId/': typeof AuthenticatedVenuesVenueIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/cli-login'
    | '/admin/review'
    | '/admin/sources'
    | '/events/mine'
    | '/events/new'
    | '/organisers/new'
    | '/venues/new'
    | '/week/$areaSlug'
    | '/events/'
    | '/organisers/'
    | '/venues/'
    | '/events/$eventId/edit'
    | '/organisers/$organiserId/edit'
    | '/series/$seriesId/edit'
    | '/venues/$venueId/edit'
    | '/events/$eventId/'
    | '/organisers/$organiserId/'
    | '/venues/$venueId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/cli-login'
    | '/admin/review'
    | '/admin/sources'
    | '/events/mine'
    | '/events/new'
    | '/organisers/new'
    | '/venues/new'
    | '/week/$areaSlug'
    | '/events'
    | '/organisers'
    | '/venues'
    | '/events/$eventId/edit'
    | '/organisers/$organiserId/edit'
    | '/series/$seriesId/edit'
    | '/venues/$venueId/edit'
    | '/events/$eventId'
    | '/organisers/$organiserId'
    | '/venues/$venueId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/cli-login'
    | '/_authenticated/admin/review'
    | '/_authenticated/admin/sources'
    | '/_authenticated/events/mine'
    | '/_authenticated/events/new'
    | '/_authenticated/organisers/new'
    | '/_authenticated/venues/new'
    | '/_authenticated/week/$areaSlug'
    | '/_authenticated/events/'
    | '/_authenticated/organisers/'
    | '/_authenticated/venues/'
    | '/_authenticated/events/$eventId/edit'
    | '/_authenticated/organisers/$organiserId/edit'
    | '/_authenticated/series/$seriesId/edit'
    | '/_authenticated/venues/$venueId/edit'
    | '/_authenticated/events/$eventId/'
    | '/_authenticated/organisers/$organiserId/'
    | '/_authenticated/venues/$venueId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthRoute: typeof AuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/cli-login': {
      id: '/_authenticated/cli-login'
      path: '/cli-login'
      fullPath: '/cli-login'
      preLoaderRoute: typeof AuthenticatedCliLoginRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/review': {
      id: '/_authenticated/admin/review'
      path: '/admin/review'
      fullPath: '/admin/review'
      preLoaderRoute: typeof AuthenticatedAdminReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/sources': {
      id: '/_authenticated/admin/sources'
      path: '/admin/sources'
      fullPath: '/admin/sources'
      preLoaderRoute: typeof AuthenticatedAdminSourcesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/mine': {
      id: '/_authenticated/events/mine'
      path: '/events/mine'
      fullPath: '/events/mine'
      preLoaderRoute: typeof AuthenticatedEventsMineRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthenticatedEventsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organisers/': {
      id: '/_authenticated/organisers/'
      path: '/organisers'
      fullPath: '/organisers/'
      preLoaderRoute: typeof AuthenticatedOrganisersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organisers/new': {
      id: '/_authenticated/organisers/new'
      path: '/organisers/new'
      fullPath: '/organisers/new'
      preLoaderRoute: typeof AuthenticatedOrganisersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/venues/': {
      id: '/_authenticated/venues/'
      path: '/venues'
      fullPath: '/venues/'
      preLoaderRoute: typeof AuthenticatedVenuesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/venues/new': {
      id: '/_authenticated/venues/new'
      path: '/venues/new'
      fullPath: '/venues/new'
      preLoaderRoute: typeof AuthenticatedVenuesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/week/$areaSlug': {
      id: '/_authenticated/week/$areaSlug'
      path: '/week/$areaSlug'
      fullPath: '/week/$areaSlug'
      preLoaderRoute: typeof AuthenticatedWeekAreaSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/$eventId/': {
      id: '/_authenticated/events/$eventId/'
      path: '/events/$eventId'
      fullPath: '/events/$eventId/'
      preLoaderRoute: typeof AuthenticatedEventsEventIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/$eventId/edit': {
      id: '/_authenticated/events/$eventId/edit'
      path: '/events/$eventId/edit'
      fullPath: '/events/$eventId/edit'
      preLoaderRoute: typeof AuthenticatedEventsEventIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organisers/$organiserId/': {
      id: '/_authenticated/organisers/$organiserId/'
      path: '/organisers/$organiserId'
      fullPath: '/organisers/$organiserId/'
      preLoaderRoute: typeof AuthenticatedOrganisersOrganiserIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organisers/$organiserId/edit': {
      id: '/_authenticated/organisers/$organiserId/edit'
      path: '/organisers/$organiserId/edit'
      fullPath: '/organisers/$organiserId/edit'
      preLoaderRoute: typeof AuthenticatedOrganisersOrganiserIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$seriesId/edit': {
      id: '/_authenticated/series/$seriesId/edit'
      path: '/series/$seriesId/edit'
      fullPath: '/series/$seriesId/edit'
      preLoaderRoute: typeof AuthenticatedSeriesSeriesIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/venues/$venueId/': {
      id: '/_authenticated/venues/$venueId/'
      path: '/venues/$venueId'
      fullPath: '/venues/$venueId/'
      preLoaderRoute: typeof AuthenticatedVenuesVenueIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/venues/$venueId/edit': {
      id: '/_authenticated/venues/$venueId/edit'
      path: '/venues/$venueId/edit'
      fullPath: '/venues/$venueId/edit'
      preLoaderRoute: typeof AuthenticatedVenuesVenueIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCliLoginRoute: typeof AuthenticatedCliLoginRoute
  AuthenticatedAdminReviewRoute: typeof AuthenticatedAdminReviewRoute
  AuthenticatedAdminSourcesRoute: typeof AuthenticatedAdminSourcesRoute
  AuthenticatedEventsMineRoute: typeof AuthenticatedEventsMineRoute
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute
  AuthenticatedOrganisersNewRoute: typeof AuthenticatedOrganisersNewRoute
  AuthenticatedVenuesNewRoute: typeof AuthenticatedVenuesNewRoute
  AuthenticatedWeekAreaSlugRoute: typeof AuthenticatedWeekAreaSlugRoute
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
  AuthenticatedOrganisersIndexRoute: typeof AuthenticatedOrganisersIndexRoute
  AuthenticatedVenuesIndexRoute: typeof AuthenticatedVenuesIndexRoute
  AuthenticatedEventsEventIdEditRoute: typeof AuthenticatedEventsEventIdEditRoute
  AuthenticatedOrganisersOrganiserIdEditRoute: typeof AuthenticatedOrganisersOrganiserIdEditRoute
  AuthenticatedSeriesSeriesIdEditRoute: typeof AuthenticatedSeriesSeriesIdEditRoute
  AuthenticatedVenuesVenueIdEditRoute: typeof AuthenticatedVenuesVenueIdEditRoute
  AuthenticatedEventsEventIdIndexRoute: typeof AuthenticatedEventsEventIdIndexRoute
  AuthenticatedOrganisersOrganiserIdIndexRoute: typeof AuthenticatedOrganisersOrganiserIdIndexRoute
  AuthenticatedVenuesVenueIdIndexRoute: typeof AuthenticatedVenuesVenueIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCliLoginRoute: AuthenticatedCliLoginRoute,
  AuthenticatedAdminReviewRoute: AuthenticatedAdminReviewRoute,
  AuthenticatedAdminSourcesRoute: AuthenticatedAdminSourcesRoute,
  AuthenticatedEventsMineRoute: AuthenticatedEventsMineRoute,
  AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
  AuthenticatedOrganisersNewRoute: AuthenticatedOrganisersNewRoute,
  AuthenticatedVenuesNewRoute: AuthenticatedVenuesNewRoute,
  AuthenticatedWeekAreaSlugRoute: AuthenticatedWeekAreaSlugRoute,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
  AuthenticatedOrganisersIndexRoute: AuthenticatedOrganisersIndexRoute,
  AuthenticatedVenuesIndexRoute: AuthenticatedVenuesIndexRoute,
  AuthenticatedEventsEventIdEditRoute: AuthenticatedEventsEventIdEditRoute,
  AuthenticatedOrganisersOrganiserIdEditRoute:
    AuthenticatedOrganisersOrganiserIdEditRoute,
  AuthenticatedSeriesSeriesIdEditRoute: AuthenticatedSeriesSeriesIdEditRoute,
  AuthenticatedVenuesVenueIdEditRoute: AuthenticatedVenuesVenueIdEditRoute,
  AuthenticatedEventsEventIdIndexRoute: AuthenticatedEventsEventIdIndexRoute,
  AuthenticatedOrganisersOrganiserIdIndexRoute:
    AuthenticatedOrganisersOrganiserIdIndexRoute,
  AuthenticatedVenuesVenueIdIndexRoute: AuthenticatedVenuesVenueIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
